import React, {useEffect,useMemo,useState} from 'react';
import {useSelector} from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import config from '../../../config';

export default function SubscriptionSignature({signature,onStatusChange}) {
  const token=useSelector(state=>state.auth?.token);
  const [image,setImage]=useState({status:'loading',source:''});
  const recorded=signature?.status==='recorded';
  const clientId=signature?.client_id,saleId=signature?.sale_id,planId=signature?.plan_id;
  const requestIdentity=useMemo(()=>({}),[recorded,clientId,saleId,planId,token]);
  useEffect(()=>{
    if(!recorded)return undefined;
    if(!token || ![clientId,saleId,planId].every(value=>Number.isSafeInteger(Number(value)) && Number(value)>0)){
      setImage({status:'error',source:'',requestIdentity});return undefined;
    }
    let active=true,objectUrl='';
    const controller=new AbortController();setImage({status:'loading',source:'',requestIdentity});
    axios.get(`${config.API_URL}afterlogin/sale/${Number(saleId)}/clients/${Number(clientId)}/subscriptions/${Number(planId)}/signature`,{
      headers:{Authorization:`Bearer ${token}`},responseType:'blob',signal:controller.signal,
    }).then(response=>{
      const content=response?.data;
      // Legacy signatures can exceed the new-upload limit; bound reads to 1 MiB.
      if(!(content instanceof Blob) || !['image/png','image/jpeg'].includes(content.type) || content.size>1024*1024)throw new Error('Invalid signature content');
      objectUrl=URL.createObjectURL(content);
      if(active)setImage({status:'ready',source:objectUrl,requestIdentity});
      else {URL.revokeObjectURL(objectUrl);objectUrl='';}
    }).catch(()=>{if(active)setImage({status:'error',source:'',requestIdentity});});
    return ()=>{active=false;controller.abort();if(objectUrl)URL.revokeObjectURL(objectUrl);};
  },[recorded,clientId,saleId,planId,token,requestIdentity]);
  useEffect(()=>{
    onStatusChange?.(!recorded?'not_recorded':image.requestIdentity===requestIdentity?image.status:'loading');
  },[recorded,image,requestIdentity,onStatusChange]);
  if(!recorded)return <div>Signature not recorded or unavailable for this purchase.</div>;
  if(image.requestIdentity!==requestIdentity)return <div role="status">Loading signature</div>;
  if(image.status==='error')return <div role="status">Signature unavailable</div>;
  if(image.status!=='ready')return <div role="status">Loading signature</div>;
  return <div><div>Client signature</div><img src={image.source} alt="Client signature" style={{width:'150px',height:'auto'}} onError={()=>setImage({status:'error',source:'',requestIdentity})}/></div>;
}

SubscriptionSignature.propTypes={onStatusChange:PropTypes.func,signature:PropTypes.shape({
  status:PropTypes.string,
  client_id:PropTypes.oneOfType([PropTypes.number,PropTypes.string]),
  sale_id:PropTypes.oneOfType([PropTypes.number,PropTypes.string]),
  plan_id:PropTypes.oneOfType([PropTypes.number,PropTypes.string]),
})};
